import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BottomModal from '../../../../components/modal/bottomModal';
import { splitBillSteps } from '../../models/splitBillSteps';
import SplitBillCustom from './custom';
import SplitBillDivide from './divide';
import SplitBillItems from './items';
import SplitBillOptions from './options';

const SplitBillModal = ({ order, table, open, onToggle, onConfirm }) => {
  const { t } = useTranslation();

  const [step, setStep] = useState(splitBillSteps.options);

  useEffect(() => {
    if (open && step !== splitBillSteps.options) {
      setStep(splitBillSteps.options);
    }
  }, [open]);

  const renderTitle = () => {
    switch (step) {
      case splitBillSteps.options:
        return t('buttons.splitBill');
      case splitBillSteps.custom:
        return t('buttons.payCustom');
      case splitBillSteps.divide:
        return t('buttons.divideBillEqually');
      case splitBillSteps.items:
        return t('buttons.payForItems');
      default:
        return null;
    }
  };

  const renderContent = () => {
    switch (step) {
      case splitBillSteps.options:
        return <SplitBillOptions onSelect={setStep} />;
      case splitBillSteps.custom:
        return (
          <SplitBillCustom
            order={order}
            onConfirm={(amount) => {
              onConfirm(splitBillSteps.custom, { subtotal: amount, orderId: order.id });
            }}
          />
        );
      case splitBillSteps.divide:
        return (
          <SplitBillDivide
            table={table}
            order={order}
            onConfirm={(amount) => {
              onConfirm(splitBillSteps.divide, { subtotal: amount, orderId: order.id });
            }}
          />
        );
      case splitBillSteps.items:
        return (
          <SplitBillItems
            order={order}
            onConfirm={(amount, items) => {
              onConfirm(splitBillSteps.items, { subtotal: amount, orderId: order.id, items });
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <BottomModal
      title={renderTitle()}
      content={renderContent()}
      onClose={() => {
        if (step === splitBillSteps.options) {
          onToggle(!open);
        } else {
          setStep(splitBillSteps.options);
        }
      }}
      onOutClick={() => onToggle(false)}
      open={open}
    />
  );
};

export default SplitBillModal;
